import { merge } from 'lodash'
import { vat, TYPES as VAT_TYPES } from './vat/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      vat: {
        namespaced: true,
        modules: {
          vat
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    VAT_TYPES
  )

export { store, TYPES }
